import { Inject, Injectable, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HelpersService } from './helpers.service';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()


export class UsersService extends HelpersService {
    constructor(protected override http: HttpClient,
        protected override router: Router,
        @Inject(PLATFORM_ID) protected override platformId: Object,
        protected override cookieService: CookieService,
        protected override title: Title,
        protected override translate: TranslateService,
        protected override meta: Meta,
        protected override modalService: NgbModal,
        protected override viewportScroller: ViewportScroller,
        @Inject(DOCUMENT) protected override doc: Document) {
        super(http, router, platformId, cookieService, title, translate, meta, modalService, viewportScroller, doc);
    }

    public login(reqLogin: any): Observable<any> {
        const url = `${environment.urlApi}/oauth/token`;
        const req = {
            client_id: environment.client_id_secret_preview,
            client_secret: environment.client_secret,
            grant_type: 'password',
            password: reqLogin.password,
            username: reqLogin.username
        };
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded;');
        const body = 'client_id=' + req.client_id + '&client_secret=' + req.client_secret + '&grant_type=' + req.grant_type + '&password=' + req.password + '&username=' + req.username;
        return this.http.post(url, body, { headers }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

}

